import Page, { PageTab } from "../../../../shared/components/Page";
import BankedMinutesJobsTab from "./BankedMinutesJobsTab";
import BankedMinutesViewTab from "./BankedMinutesViewTab";

const tabs: PageTab[] = [
  {
    header: "View",
    route: "app.banked_minutes.view",
    component: <BankedMinutesViewTab />,
  },
  {
    header: "Jobs",
    route: "app.banked_minutes.jobs",
    component: <BankedMinutesJobsTab />,
  },
];

export default function BankedMinutesRoute() {
  return <Page.Tabbed tabs={tabs} />;
}
